<template>
    <div v-if="isActif">
        <button
            v-if="!panneauOuvert"
            type="button"
            class="regles-menus__bouton-ouvrir"
            :title="$t('regles_gestion.menus.ouvrir')"
            @click="ouvrir"
        >
            RÈGLES DES MENUS
        </button>
        <div v-else class="regles-menus">
            <div class="regles-menus__entete">
                <span>Règles d'affichage des menus</span>
                <button type="button" class="regles-menus__fermer" @click="fermer">&times;</button>
            </div>
            <div class="regles-menus__contenu">
                <div v-for="groupe in REGLES_MENUS" :key="groupe.titre" class="regles-menus__groupe">
                    <div class="regles-menus__groupe-titre">{{ groupe.titre }}</div>
                    <div v-for="item in groupe.items" :key="item.titre" class="regles-menus__item">
                        <div class="regles-menus__item-titre">{{ item.titre }}</div>
                        <div class="regles-menus__item-condition">{{ item.condition }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { REGLES_MENUS } from '@/regles/reglesMenus';

export default defineComponent({
    name: 'ReglesMenusPanneau',
    data() {
        return {
            REGLES_MENUS,
            panneauOuvert: false,
        };
    },
    computed: {
        isActif(): boolean {
            return (
                this.$store.getters['reglesGestionState/isActif'] &&
                this.envAutoriseReglesGestion &&
                !!this.$store.getters.getUserInformations?.fonctions?.includes('acces.reglesmetier')
            );
        },
        envAutoriseReglesGestion(): boolean {
            return ['DEV', 'INT', 'REC'].includes((window.CONFIG?.env || '').toUpperCase());
        },
    },
    methods: {
        ouvrir() {
            this.panneauOuvert = true;
        },
        fermer() {
            this.panneauOuvert = false;
        },
    },
});
</script>

<style scoped>
.regles-menus__bouton-ouvrir {
    position: fixed;
    /* même ligne que RDG (ReglesPanneau.vue), côte à côte, à gauche du bouton RDG */
    bottom: 24px;
    right: 210px;
    z-index: 1005;
    border-radius: 24px;
    border: none;
    padding: 10px 16px;
    background-color: var(--bleu-prinicipal);
    color: #fff;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    white-space: nowrap;
}
.regles-menus {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 380px;
    max-width: 90vw;
    background-color: #fff;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.2);
    z-index: 1006;
    display: flex;
    flex-direction: column;
}
.regles-menus__entete {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background-color: var(--bleu-prinicipal);
    color: #fff;
    font-weight: bold;
}
.regles-menus__fermer {
    background: none;
    border: none;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    line-height: 1;
}
.regles-menus__contenu {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0;
}
.regles-menus__groupe-titre {
    padding: 10px 16px 4px;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.4px;
    color: var(--bleu-secondaire);
}
.regles-menus__item {
    padding: 8px 16px;
    border-bottom: 1px solid #e5e7eb;
}
.regles-menus__item-titre {
    font-weight: bold;
    color: var(--bleu-prinicipal);
    margin-bottom: 2px;
}
.regles-menus__item-condition {
    font-size: 13px;
    color: #374151;
}
</style>
